import { PlanTier } from '@zapier/design-system-revenue/src/types';

export const isTierFree = (tier: PlanTier): boolean => tier.pricePerTask === 0;
